var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"captcha"},[_c('VueHcaptcha',{ref:"hcaptcha",attrs:{"size":"invisible","sitekey":_vm.sitekey},on:{"verify":function($event){return _vm.$emit('onVerify', $event)},"expired":_vm.onCaptchaExpired}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }